import { saveAs } from 'file-saver';

import { DefaultApi } from '../autogenerated/spdApiClient';
import { CertificateResponseDto } from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { certificateForGrid } from '../../../spd/components/Certificates/CertificateGrid';
import {
  CertificateGenerateSchema,
  CertificatePasswordSchema,
} from '../validation/schemas';
import { validateAgainst } from '../validation/validateAgainst';

export interface CertificateContextInterface {
  getAllCount: (filterText?: string) => Promise<number>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    onDownloadCert?: (cert: CertificateResponseDto) => void,
  ) => Promise<GridRecord[]>;
  generate: (
    commonName: string,
    pfxPassword: string,
  ) => Promise<CertificateResponseDto>;
  downloadRootCa: () => Promise<void>;
  downloadCertificateWithKey: (
    id: string,
    pfxPassword: string,
    commonName: string,
  ) => Promise<void>;
}
export const CertificateContext = (
  api: DefaultApi,
): CertificateContextInterface => {
  return {
    getAllCount: (filterText?: string) =>
      api.certificateAuthorityControllerGetAllCount(filterText || ''),

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      onDownloadCert?: (cert: CertificateResponseDto) => void,
    ) => {
      const data = await api.certificateAuthorityControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(cert => certificateForGrid(cert, onDownloadCert));
    },

    generate: async (commonName: string, pfxPassword: string) => {
      return await api.certificateAuthorityControllerGenerateCertificate({
        commonName: commonName,
        pfxPassword: pfxPassword,
      });
    },

    downloadRootCa: async () => {
      const response = await api.certificateAuthorityControllerDownloadRootCA();
      const blob = response;
      saveAs(blob, 'spd_root_ca.crt');
    },

    downloadCertificateWithKey: async (
      id: string,
      pfxPassword: string,
      commonName: string,
    ) => {
      const response =
        await api.certificateAuthorityControllerDownloadCertificateWithKey(id, {
          pfxPassword: pfxPassword,
        });
      const blob = response;
      saveAs(blob, `${commonName}.pfx`);
    },
  };
};

export const validateCertificateGenerate = (data: {
  commonName: string;
  password: string;
}) => validateAgainst(CertificateGenerateSchema, data);

export const validateCertificatePassword = (data: { password: string }) =>
  validateAgainst(CertificatePasswordSchema, data);
